// The policy and section navigation work without JavaScript.
(() => {
  const menu = document.getElementById('mobile-menu');
  const toggle = document.querySelector('.menu-toggle');
  if (!menu || !toggle) return;
  const setOpen = open => {
    menu.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
  };
  toggle.addEventListener('click', () => setOpen(menu.hidden));
  document.querySelectorAll('.mobile-menu a').forEach(link => link.addEventListener('click', () => setOpen(false)));
})();
